/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import {
  JoysticksFlightMode_Enum,
  joysticksFlightMode_EnumFromJSON,
  joysticksFlightMode_EnumToJSON,
} from "./joysticks_flight_mode";
import { Rates } from "./rates";

export const protobufPackage = "joysticks";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface JoysticksSettings {
  utime: number;
  rates: Rates | undefined;
  flightMode: JoysticksFlightMode_Enum;
  horizontalGeofenceEnabled: boolean;
  horizontalGeofenceDistance: number;
  flipTriggers: boolean;
}

function createBaseJoysticksSettings(): JoysticksSettings {
  return {
    utime: 0,
    rates: undefined,
    flightMode: 0,
    horizontalGeofenceEnabled: false,
    horizontalGeofenceDistance: 0,
    flipTriggers: false,
  };
}

export const JoysticksSettings = {
  encode(message: JoysticksSettings, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).uint64(message.utime);
    }
    if (message.rates !== undefined) {
      Rates.encode(message.rates, writer.uint32(98).fork()).ldelim();
    }
    if (message.flightMode !== 0) {
      writer.uint32(24).int32(message.flightMode);
    }
    if (message.horizontalGeofenceEnabled === true) {
      writer.uint32(32).bool(message.horizontalGeofenceEnabled);
    }
    if (message.horizontalGeofenceDistance !== 0) {
      writer.uint32(45).float(message.horizontalGeofenceDistance);
    }
    if (message.flipTriggers === true) {
      writer.uint32(88).bool(message.flipTriggers);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): JoysticksSettings {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseJoysticksSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.uint64() as Long);
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.rates = Rates.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.flightMode = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.horizontalGeofenceEnabled = reader.bool();
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.horizontalGeofenceDistance = reader.float();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.flipTriggers = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): JoysticksSettings {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      rates: isSet(object.rates) ? Rates.fromJSON(object.rates) : undefined,
      flightMode: isSet(object.flightMode) ? joysticksFlightMode_EnumFromJSON(object.flightMode) : 0,
      horizontalGeofenceEnabled: isSet(object.horizontalGeofenceEnabled)
        ? globalThis.Boolean(object.horizontalGeofenceEnabled)
        : false,
      horizontalGeofenceDistance: isSet(object.horizontalGeofenceDistance)
        ? globalThis.Number(object.horizontalGeofenceDistance)
        : 0,
      flipTriggers: isSet(object.flipTriggers) ? globalThis.Boolean(object.flipTriggers) : false,
    };
  },

  toJSON(message: JoysticksSettings): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.rates !== undefined) {
      obj.rates = Rates.toJSON(message.rates);
    }
    if (message.flightMode !== 0) {
      obj.flightMode = joysticksFlightMode_EnumToJSON(message.flightMode);
    }
    if (message.horizontalGeofenceEnabled === true) {
      obj.horizontalGeofenceEnabled = message.horizontalGeofenceEnabled;
    }
    if (message.horizontalGeofenceDistance !== 0) {
      obj.horizontalGeofenceDistance = message.horizontalGeofenceDistance;
    }
    if (message.flipTriggers === true) {
      obj.flipTriggers = message.flipTriggers;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<JoysticksSettings>, I>>(base?: I): JoysticksSettings {
    return JoysticksSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<JoysticksSettings>, I>>(object: I): JoysticksSettings {
    const message = createBaseJoysticksSettings();
    message.utime = object.utime ?? 0;
    message.rates = (object.rates !== undefined && object.rates !== null) ? Rates.fromPartial(object.rates) : undefined;
    message.flightMode = object.flightMode ?? 0;
    message.horizontalGeofenceEnabled = object.horizontalGeofenceEnabled ?? false;
    message.horizontalGeofenceDistance = object.horizontalGeofenceDistance ?? 0;
    message.flipTriggers = object.flipTriggers ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
